import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServeSendEventService {


  constructor(private zone: NgZone) { }


  createEventSourceOrderMachine(orderId: string) {
      const topicUri = `pagarme/order/${orderId}`;
      const eventSource = new EventSource(`${environment.url_mercure}/.well-known/mercure?topic=` + topicUri);

      return new Observable(observer => {
          eventSource.onmessage = event => {
            this.zone.run(() => {
              const messageData: {status: string} = JSON.parse(event.data);
              observer.next(messageData.status);
              if(messageData.status == 'paid' || messageData.status == 'canceled') {
                eventSource.close();
                observer.complete();
              }
            })
        };
        
      });
  }
}
